"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsafeHTML = void 0;
const parts_js_1 = require("../lib/parts.js");
const lit_html_js_1 = require("../lit-html.js");
const previousValues = new WeakMap();
exports.unsafeHTML = (0, lit_html_js_1.directive)((value) => (part) => {
    if (!(part instanceof lit_html_js_1.NodePart)) {
        throw new Error('unsafeHTML can only be used in text bindings');
    }
    const previousValue = previousValues.get(part);
    if (previousValue !== undefined && (0, parts_js_1.isPrimitive)(value) &&
        value === previousValue.value && part.value === previousValue.fragment) {
        return;
    }
    const template = document.createElement('template');
    template.innerHTML = value;
    const fragment = document.importNode(template.content, true);
    part.setValue(fragment);
    previousValues.set(part, { value, fragment });
});
